export default {
  //* updateClient ---------------------------------------------------------------------------------------------------------------

  updateClient(context, data) {
    context.commit("updateClient", data);
  },

  //* loadClients ---------------------------------------------------------------------------------------------------------------

  async loadClients({ rootGetters, commit }) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getContact/all", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setClients", resp_json);
      localStorage.setItem("clients", JSON.stringify(resp_json));
    }
  },

  //* loadClientsLazy ---------------------------------------------------------------------------------------------------------------

  async loadClientsLazy({ rootGetters }, dati) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getContact/lazy", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* loadClientsLazy ---------------------------------------------------------------------------------------------------------------

  async loadClientsLazyCV({ rootGetters }, dati) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getContact/lazyCV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      console.log(resp_json)
      return resp_json;
    }
    return {};
  },

  //* getContact ---------------------------------------------------------------------------------------------------------------

  async getContact({ rootGetters }, id) {
    //if(id != undefined){
    // load contacts from backend
    /*
        ! ATTENTION:
        commit to store not added !
      */
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getContact/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      if (resp_json._id != -1) {
        return resp_json;
      }
      return null;
    }
    return {};
  },

  //* getUser ---------------------------------------------------------------------------------------------------------------

  async getUser({ rootGetters }, id) {
    //if(id != undefined){
    // load contacts from backend
    /*
        ! ATTENTION:
        commit to store not added !
      */
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getUser/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      if (resp_json._id != -1) {
        return resp_json;
      }
      return null;
    }
    return {};
  },

  //* getContactNoAuth ---------------------------------------------------------------------------------------------------------------

  async getContactNoAuth({ rootGetters }, payload) {
    //if(id != undefined){
    // load contacts from backend
    /*
        ! ATTENTION:
        commit to store not added !
      */
    // console.log(payload.cliente);
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(
      base_address + "/getContact/noAuth/" + payload.cliente,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify({
          camping: payload.camping,
        }),
      }
    ).catch((e) => console.log(e));

    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* patchClient ---------------------------------------------------------------------------------------------------------------

  async patchClient({ rootGetters }, data_inp) {
    // @payload needs the id of the contact and all the attributes needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var payload = { ...data_inp };
    const idContact = payload._id;
    // otherwise the patch is not permitted
    delete payload._id;
    delete payload.camping;
    delete payload.owner;
    delete payload.__v;
    delete payload.date_creation;
    if ("language" in payload) delete payload.language;
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editContact/" + idContact, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    if (response.ok) {
      ret_val["ok"] = 200;
    } else {
      ret_val["ok"] = 400;
    }
    return ret_val;
  },

  //* addClient ---------------------------------------------------------------------------------------------------------------

  async addClient({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/addContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      const resp = response.json();
      ret_val = resp;
    });
    return ret_val;
  },

  //* deleteClient ---------------------------------------------------------------------------------------------------------------

  async deleteClient({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteContact/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* queryClients ---------------------------------------------------------------------------------------------------------------

  async queryClients({ rootGetters }, query) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/contactQuery", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(query),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* queryClientsCV---------------------------------------------------------------------------------------------------------------

  async queryClientsCV({ rootGetters }, query) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/contactQueryCV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(query),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* clientFind ---------------------------------------------------------------------------------------------------------------

  clientFind({ rootGetters }, clienteID) {
    var clienti = rootGetters["clients/clients"];
    return clienti.find((cliente) => cliente._id === clienteID);
  },

  //* Export Contatti ---------------------------------------------------------------------------------------------------------------
  downloadBlob(filename, text) {
    var pom = document.createElement('a');
    pom.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
    pom.setAttribute('download', filename);

    if (document.createEvent) {
        var event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        pom.dispatchEvent(event);
    }
    else {
        pom.click();
    }
  },
  async exportContacts({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/exportContacts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).catch((error) => console.log(error));
    // senza questo controllo una risposta di errore finiva scaricata come CSV
    if (!response || !response.ok) {
      return false;
    }
    const responseText = await response.text();

    // Blob invece di un link data: che con migliaia di contatti supera il limite di lunghezza del browser;
    // il BOM fa riconoscere a Excel la codifica UTF-8 (lettere accentate)
    const url = URL.createObjectURL(new Blob(["﻿" + responseText], { type: "text/csv;charset=utf-8" }));
    var pom = document.createElement('a');
    pom.setAttribute('href', url);

    const nowTime = new Date()
    pom.setAttribute('download', 'ExportDati_' + nowTime.getFullYear() + '-' + (parseInt(nowTime.getMonth()) + 1).toString().padStart(2, "0") + '-' + nowTime.getDate().toString().padStart(2, "0") + '.csv');

    if (document.createEvent) {
        var event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        pom.dispatchEvent(event);
    }
    else {
        pom.click();
    }
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  },
};
